export default __webpack_public_path__ + "static/media/texp9.45f1a28d.png";